import { Text, type PlacementWithLogical } from '@chakra-ui/react';
import React from 'react';
import CopyButton from '../../CopyButton';

interface VinProps {
    vin: string;
    /** Copy tooltip placement. Pass `bottom` for the first table row so the bubble clears the sticky header. */
    copyPlacement?: PlacementWithLogical;
}

const Vin = ({ vin, copyPlacement = 'top' }: VinProps) => {
    return (
        <span data-table-vin>
            <CopyButton
                text={vin}
                label="Copy VIN"
                placement={copyPlacement}
                tooltipAnchor={
                    <Text fontSize="xs" color="gray.500" fontFamily="mono">
                        {vin}
                    </Text>
                }
                _hover={{ color: 'gray.600', bg: 'gray.100' }}
                minW="auto"
                h="auto"
                p={1}
            />
        </span>
    );
};

export default Vin;
